// API Configuration for Jury Portal
const HOST = "https://register-service.vietnamyounglions.net/";
//const HOST = "http://vny-2025/";

const buildApiUrl = (endpoint: string): string => {
  return `${HOST}${endpoint}`;
};

export const API_URL = {
  HOST,
  BASE_API: `${HOST}api/`,

  // Jury Authentication
  AUTH: {
    LOGIN: buildApiUrl("api/jury/login"),
    LOGOUT: buildApiUrl("api/jury/logout"),
    ME: buildApiUrl("api/jury/me"),
    CHANGE_PASSWORD: buildApiUrl("api/jury/change-password"),
  },

  // Jury Assignments
  ASSIGNMENTS: {
    LIST: buildApiUrl("api/jury/assignments"),
    DETAIL: buildApiUrl("api/jury/assignments"), // + /{id}
    START_SCORING: buildApiUrl("api/jury/assignments"), // + /{id}/start
    SUBMIT_SCORE: buildApiUrl("api/jury/assignments"), // + /{id}/score
  },

  // Submission files (served via backend proxy - files are private on S3)
  FILES: {
    DOWNLOAD: buildApiUrl("api/jury/files"),    // + /{submission_id}/{file_type}
    SIGNED_URL: buildApiUrl("api/jury/files"),  // + /{submission_id}/{file_type}/signed
  },
} as const;

export { HOST };
